import { useSelector } from 'react-redux';
import { RootState } from 'store';

type InteractionBlockerProps = {
  children: React.ReactNode;
	isBlocking?: boolean;
};

export const InteractionBlocker: React.FC<InteractionBlockerProps> = ({ children, isBlocking }: InteractionBlockerProps) => {
	const isSaving = useSelector((state: RootState) => state.saveDesignState.isSaveInProgress);
	const addOverlay = isSaving || isBlocking;
	return (
		<div style={{ position: 'relative' , width: '100%'}}>
			{children}
			{addOverlay && (
				<div
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						pointerEvents: 'all',
						backgroundColor: 'transparent',
						zIndex: 99,
						minHeight: '100%',
						minWidth: '100%',
						cursor: 'not-allowed'
					}}
				/>
			)}
		</div>
	);
};
